import sessionStorageUtils from './sessionStorageUtils';
const isIntegratedAppCache = {
  Forms: null,
  LiveChat: null
};
export const APP_SESSION_KEY = {
  Forms: 'WP_IS_INTEGRATED_FORMS_APP',
  LiveChat: 'WP_IS_INTEGRATED_LIVECHAT_APP'
};
export const clearIsIntegratedFormsAppCachedForTests = () => {
  isIntegratedAppCache.Forms = null;
};
export const clearIsIntegratedLiveChatAppCachedForTests = () => {
  isIntegratedAppCache.LiveChat = null;
};

const checkIfReferredFromIntegratedApp = type => {
  if (!document.referrer || !window.hubspot) {
    return false;
  }

  const referrer = new URL(document.referrer);
  const portalId = window.hubspot.portal && window.hubspot.portal.id;

  switch (type) {
    case 'Forms':
      return referrer.pathname === `/integrated-forms-ui/${portalId}/create/type` || referrer.pathname === `/integrated-forms-ui/${portalId}/dashboard`;
      break;

    case 'LiveChat':
      return referrer.pathname === `/integrated-livechat-ui/${portalId}` || referrer.pathname === `/integrated-livechat-ui/${portalId}/dashboard` || referrer.pathname === `/integrated-livechat-ui/${portalId}/create` || referrer.pathname === `/integrated-livechat-ui/${portalId}/create/message`;
      break;

    default:
      return false;
  }
};

const checkAndCacheIsIntegratedApp = type => {
  const isIntegratedAppSession = sessionStorageUtils.getItem(APP_SESSION_KEY[type]);

  if (isIntegratedAppSession === null) {
    isIntegratedAppCache[type] = checkIfReferredFromIntegratedApp(type);
    sessionStorageUtils.setItem(APP_SESSION_KEY[type], isIntegratedAppCache[type].toString());
  } else {
    isIntegratedAppCache[type] = isIntegratedAppSession === 'true';
  }
};

const isIntegratedApp = type => {
  if (isIntegratedAppCache[type] === null) {
    checkAndCacheIsIntegratedApp(type);
  }

  return isIntegratedAppCache[type];
};

const isIntegratedFormsApp = () => {
  return isIntegratedApp('Forms');
};

const isIntegratedLiveChatApp = () => {
  return isIntegratedApp('LiveChat');
};

export default {
  isIntegratedFormsApp,
  isIntegratedLiveChatApp,
  isIntegratedApp
};